/**
 * Cancels an in-flight post-logout apex cookie purge when the user starts a new login.
 * Without this, `POST /logout` from the purge can run after login and wipe fresh cookies.
 */
let activePurgeAbort: AbortController | null = null

export function beginApexPurge(): AbortSignal {
  activePurgeAbort?.abort()
  activePurgeAbort = new AbortController()
  return activePurgeAbort.signal
}

export function abortApexPurge(): void {
  activePurgeAbort?.abort()
  activePurgeAbort = null
}

export function isApexPurgeSignalAborted(signal: AbortSignal): boolean {
  return signal.aborted
}
